import { useEffect } from 'react';

import { setErrorHandler } from '@/store/middleware/errorLogger';

import { useSnackbar } from '@/context/snackbar/useSnackbar';

export const useGlobalErrorHandler = () => {
  const { addErrorSnackbar } = useSnackbar();

  useEffect(() => {
    setErrorHandler(addErrorSnackbar);
  }, [addErrorSnackbar]);
};
